// extracted by mini-css-extract-plugin
export default {"root":"App_root__G0q0n"};